import RepeaterBlockView from '@plone-collective/volto-repeater-block/View';

import { useIntl } from 'react-intl';

import { BlockDataForm, SidebarPortal } from '@plone/volto/components';
import config from '@plone/volto/registry';

const RepeaterBlockEditDisplay = ({ data }) => {
  if (!data.type && !data.source) {
    return <p>Repeater block</p>;
  }
  return (
    <div inert="">
      <RepeaterBlockView data={data} />
    </div>
  );
};

function RepeaterBlockEditSidebar({
  data,
  block,
  onChangeBlock,
  selected,
  blocksConfig = config.blocks.blocksConfig,
}) {
  const intl = useIntl();

  const blockSchema = blocksConfig?.[data['@type']]?.blockSchema;
  const schema =
    typeof blockSchema === 'function'
      ? blockSchema({ formData: data, intl })
      : blockSchema;

  return (
    <SidebarPortal selected={selected}>
      <BlockDataForm
        schema={schema}
        title={schema.title}
        onChangeField={(id, value) => {
          onChangeBlock(block, {
            ...data,
            [id]: value,
          });
        }}
        formData={data}
        block={block}
      />
    </SidebarPortal>
  );
}

export function RepeaterBlockEdit(props) {
  return (
    <>
      <RepeaterBlockEditDisplay
        data={props.data}
        block={props.block}
        id={props.block}
        isEditMode
      />
      <RepeaterBlockEditSidebar
        data={props.data}
        block={props.block}
        onChangeBlock={props.onChangeBlock}
        selected={props.selected}
      />
    </>
  );
}
